const config = {
    development: {
        EVO_URL: "https://ij.vinarskyobzor.cz",
    },
    testing: {
        EVO_URL: "https://testing.vinarskyobzor.cz",
    },
    production: {
        EVO_URL: "https://vinarskyobzor.cz",
    },
};

export default config;